import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-doctor-skeleton',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div
      class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 animate-pulse"
    >
      <!-- Header avec avatar et nom -->
      <div class="flex items-start space-x-4 mb-4">
        <!-- Avatar skeleton -->
        <div class="w-16 h-16 bg-gray-300 rounded-full flex-shrink-0"></div>

        <!-- Informations principales -->
        <div class="flex-1 min-w-0">
          <!-- Nom skeleton -->
          <div class="h-5 bg-gray-300 rounded w-3/4 mb-2"></div>
          <!-- Spécialité skeleton -->
          <div class="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
          <!-- Type skeleton -->
          <div class="h-4 bg-gray-300 rounded w-1/3"></div>
        </div>
      </div>

      <!-- Détails -->
      <div class="space-y-3 mb-4">
        <!-- Adresse -->
        <div class="flex items-center space-x-2">
          <div class="w-4 h-4 bg-gray-300 rounded"></div>
          <div class="h-4 bg-gray-300 rounded flex-1"></div>
        </div>

        <!-- Téléphone -->
        <div class="flex items-center space-x-2">
          <div class="w-4 h-4 bg-gray-300 rounded"></div>
          <div class="h-4 bg-gray-300 rounded w-2/3"></div>
        </div>

        <!-- Distance -->
        <div class="flex items-center space-x-2">
          <div class="w-4 h-4 bg-gray-300 rounded"></div>
          <div class="h-4 bg-gray-300 rounded w-1/4"></div>
        </div>
      </div>

      <!-- Boutons d'action -->
      <div class="flex space-x-2">
        <div class="h-10 bg-gray-300 rounded flex-1"></div>
        <div class="h-10 bg-gray-300 rounded w-20"></div>
      </div>
    </div>
  `,
  styles: [
    `
      .animate-pulse {
        animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
      }

      @keyframes pulse {
        0%,
        100% {
          opacity: 1;
        }
        50% {
          opacity: 0.5;
        }
      }
    `,
  ],
})
export class DoctorSkeletonComponent {}
